import React, { useState, useEffect, useContext } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { SelectModal } from '../../SelectModal';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import { APIContext } from '../../../Contexts/APIContext';
import AssessmentIcon from '@mui/icons-material/Assessment';

const styles = {
    root: {
        minHeight: '32px',
        backgroundColor: '#e0e0e0',
        borderRadius: '16px',
    },
    text: {
        padding: '0 12px',
    },
    button: {
        padding: 0,
        margin: '4px'
    }
}

interface IMonitoredByProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    client: string,
    currentSelection?: any,
    show: boolean;
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];
    showOnReport?: boolean;
}

export default function MonitoredByChip(props: IMonitoredByProps) {
    const [options, setOptions] = useState<any>([]);
    const { get } = useContext(APIContext);

    useEffect(() => {
        if (props.client !== '') {
            getQAs();
        }
    }, [props.client])

    const getQAs = () => {
        get('Search', `GetQADropdown?client=${props.client}`, (data) => setOptions(data));
    }

    const handleSelect = (name: any, value: any) => props.onSelect(name, value);

    const handleDelete = () => {
        if (props.removeFilter !== null && props.removeFilter !== undefined) {
            props.removeFilter(props.filterFlag, props.filterNames);
        }
    }

    return (
        <>
            {
                props.show &&
                <Grid>
                    <Grid container sx={styles.root} justifyContent="space-between" alignItems="center">
                        {props.showOnReport &&
                            <AssessmentIcon sx={{ ml: 1 }} />
                        }
                        <Grid sx={styles.text}>
                            <Typography variant="body1">{props.title}</Typography>
                        </Grid>
                        <SelectModal
                            title={props.title}
                            filterName={props.filterName}
                            mutliSelect={true}
                            currentSelection={props.currentSelection}
                            onSelect={handleSelect}
                            options={options}
                            searchable={true}
                        />
                        <Grid>
                            {props.removeFilter !== null && props.removeFilter !== undefined &&
                                <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={styles.button}>
                                    <CancelIcon />
                                </IconButton>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            }
        </>

    )
}
